import { Button } from 'antd';
import { useState } from 'react';

import { Comment } from '@app/pages/TasksList/components';
import type { NTasksList } from '@app/pages/TasksList/types/TasksList.types';

import type { FC } from 'react';

const MAX_COMMENT_COUNT = 5;

export const CommentContainer: FC<NTasksList.CommentContainerProps> = ({
  currentComments,
}) => {
  const [showAll, setShowAll] = useState(false);

  const visibleComments = showAll
    ? currentComments
    : currentComments.slice(0, MAX_COMMENT_COUNT);

  return (
    <div className="task-comment-container">
      {visibleComments.map((comment) => (
        <Comment comment={comment} key={comment.Id} />
      ))}

      {!showAll && currentComments.length > MAX_COMMENT_COUNT && (
        <Button className="show-more-button" onClick={() => setShowAll(true)}>
          Показать ещё
        </Button>
      )}
    </div>
  );
};
